import {useEffect,useState} from 'react';
import {balanceApi} from '../balance-api';
import {watchBalanceRecovery} from '../conversation-balance';
import {BALANCE_UPDATED_EVENT} from '../top-up';

export function useConversationBalance(scope:string,visible=true){
 const [failure,setFailure]=useState<{scope:string;revision:number}|null>(null);
 const [documentVisible,setDocumentVisible]=useState(()=>document.visibilityState==='visible');
 useEffect(()=>{const changed=()=>setDocumentVisible(document.visibilityState==='visible');document.addEventListener('visibilitychange',changed);return()=>document.removeEventListener('visibilitychange',changed);},[]);
 const blocked=failure?.scope===scope;
 useEffect(()=>{
  if(!blocked||!visible||!documentVisible)return;
  return watchBalanceRecovery({
   read:signal=>balanceApi.current(signal),
   every:(check,milliseconds)=>{const timer=window.setInterval(check,milliseconds);return()=>window.clearInterval(timer);},
   onFocus:check=>{window.addEventListener('focus',check);window.addEventListener(BALANCE_UPDATED_EVENT,check);return()=>{window.removeEventListener('focus',check);window.removeEventListener(BALANCE_UPDATED_EVENT,check);};},
   onVisible:check=>{const changed=()=>{if(document.visibilityState==='visible')check();};document.addEventListener('visibilitychange',changed);return()=>document.removeEventListener('visibilitychange',changed);},
  },()=>setFailure(current=>current===failure?null:current));
 },[scope,blocked,failure,visible,documentVisible]);
 return {balanceBlocked:blocked,blockBalance:()=>setFailure(current=>({scope,revision:(current?.revision??0)+1})),clearBalance:()=>setFailure(current=>current===failure?null:current)};
}
